import React from 'react';
import { useMap } from 'react-leaflet';
import L, { ControlPosition, LatLngExpression, LatLngTuple } from 'leaflet';

type Options = {
  coordinates: LatLngExpression,
  zoom: number
}

export default function ToStation({ coords }: { coords: LatLngTuple}) {
  const map: L.Map = useMap();
  const [lat, lng] = coords;

  const options: Options = React.useMemo(() => {
    return {
      coordinates: [lat, lng],
      zoom: 16,
    };
  }, [lat, lng]);

  React.useEffect(() => {
    map.panTo(options.coordinates);
  }, [map, options]);

  return null;
}

export function CustomZoomControll({ customPosition = 'topright' }: {customPosition?: ControlPosition}) {
  const map: L.Map = useMap();

  React.useEffect(() => {
    L.control.zoom({
      position: customPosition,
    }).addTo(map);
  }, [customPosition, map]);

  return null;
}
